
import { Chunk, ChunkId, CollectionState, MinimalStory } from "./types"
import { Paragraph, StoryState } from "./types"

type AnyRawNode = RawBulletedListNode | {
  type: string
  children: Array<any>
}

type RawBulletedListNode = {
  type: 'bulleted-list'
  children: Array<RawListItemNode>
} 

type RawListItemNode = {
  type: 'list-item'
  children: Array<RawListItemChildNode>
}

type RawListItemChildNode = {
  type: 'list-item-child'
  children: Array<RawLeafNode>
}

type RawLeafNode = {
  text: string
  bold?: boolean
  italic?: boolean
  type?: never
} | {
  type: 'embed'
  nodeId: string
  text?: string
  bold?: boolean
  italic?: boolean
}


function isRawBulletedListNode(node: AnyRawNode): node is RawBulletedListNode {
  return node.type === 'bulleted-list'
}

function processStory(item: MinimalStory): Array<Paragraph> {

  const topLevelNodes: Array<AnyRawNode> = item.problematicText.raw.children;
  const lists: Array<RawBulletedListNode> = topLevelNodes.filter(isRawBulletedListNode)

  let flatIndex = 0

  const paragraphs: Array<Paragraph> = lists.map((list, i) => {
    return list.children.map((listItem, j) => {

      const nodes = listItem.children[0].children
      const chunkData: Chunk = {
        id: String(flatIndex) as ChunkId,
        text: '',
        trailing: '',
        problematic: false,
        italic: false,
        isSelected: false,
        userComment: null,
        voxComment: null,
      }

      nodes.forEach((node) => {
        if (node.text) {
          if (node.bold) {
            chunkData.trailing = node.text
          } else {
            chunkData.text += node.text
            if (node.italic) chunkData.italic = true
          }
        }
        if (node.type === 'embed') {
          chunkData.voxComment = item.comments.find((comment) => comment.id === node.nodeId) ?? null
          chunkData.problematic = true
        }
      })

      const trimmed = chunkData.text.trim()

      if (chunkData.text.length && trimmed.length !== chunkData.text.length) {
        chunkData.text = trimmed
        chunkData.trailing = ' '
      }

      flatIndex++
      return chunkData
    })
  })

  return paragraphs
}

export function createAppState(items: Array<MinimalStory>, initialActiveStorySlug: string | null): CollectionState {
  
  return items.map((item, index) => {
    const isActive = initialActiveStorySlug ? item.slug === initialActiveStorySlug : index === 0
    const paragraphs = processStory(item)
    const storyState: StoryState = {
      ...item,
      content: paragraphs,
      mode: 'edit',
      isActive,
    } 
    return storyState
  })
}

export function findSelectedChunk(story?: StoryState) {
  if (!story) return;
  return story.content.flat().find((chunk) => chunk.isSelected)
}